import { createSlice } from "@reduxjs/toolkit";
import { FetchAnalyticsList } from "./analyticsAction";

interface InventoryState {
  analytics: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
  openAnalyticsModal: boolean;
  modalData: any;
}

const initialState: InventoryState = {
  analytics: [],
  loading: false,
  error: null,
  totalRecord: 0,
  openAnalyticsModal: false,
  modalData: [],
};

const inventorySlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setOpenAnalyticsModal: (state, { payload }) => {
      state.openAnalyticsModal = true;
      state.modalData = payload;
    },
    setCloseAnalyticsModal: (state) => {
      state.openAnalyticsModal = false;
      state.modalData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchAnalyticsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchAnalyticsList.fulfilled, (state, { payload }) => {

        console.log(payload.data,">>> pa")
        state.loading = false;
        state.analytics = payload.data; // Store full inventory details
        // state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchAnalyticsList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch inventory status";
      });
  },
});

export const { setOpenAnalyticsModal, setCloseAnalyticsModal } = inventorySlice.actions;

export const analyticsReducer = inventorySlice.reducer;
